import React from 'react';

const NewCloseIconn = ({ size = 20, color = '#000000', ...props }) => (
  <svg
    height={size}
    width={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke={color}
        stroke-width="2"
      ></circle>{' '}
      <path
        d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
      ></path>{' '}
    </g>
  </svg>
);

export default NewCloseIconn;
